<div class="embed-video-player">
  <div #host class="embed-video-player__host"></div>
</div>
